/** Auth-segédek (nem komponensek — külön fájlban a Fast Refresh miatt). */

export function isEmail(v: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}

/** Csak saját, `/app` alatti útvonalra engedünk vissza-irányítást (open redirect ellen). */
export function safeNext(raw: string | null): string {
  return raw && raw.startsWith("/app") ? raw : "";
}
